import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import "./VerifyEmail.css";
import base_url from "../api";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus("error");
        setMessage("Verification token is missing.");
        return;
      }

      try {
        const res = await fetch(
          `${base_url}/verify-email?token=${encodeURIComponent(
            token
          )}`
        );
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message || "Verification failed.");
        }

        setStatus("success");
        setMessage(data.message || "Email verified successfully.");
      } catch (err) {
        setStatus("error");
        setMessage(err.message || "Verification failed. Please try again.");
      }
    };

    verify();
  }, [token]);

  return (
    <section className="verify-section">
      <div className="verify-card">
        <h2>{status === "success" ? "Email Verified" : "Verify Email"}</h2>
        <p className={status === "error" ? "verify-error" : "verify-info"}>
          {message}
        </p>

        <Link to="/login" className="verify-button">
          Go to Login
        </Link>
      </div>
    </section>
  );
};

export default VerifyEmail;

